import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon } from 'lucide-react';
interface CtaButtonProps {
  label?: string;
  showCuotas?: boolean;
  showPaymentSeal?: boolean;
  checkout?: boolean;
  subtitle?: string;
  large?: boolean;
  showPrice?: boolean;
}
export function CtaButton({
  label = 'SÍ, QUIERO LAS 250 RECETAS Y LOS 5 BONOS',
  showCuotas = true,
  showPaymentSeal = false,
  checkout = false,
  subtitle,
  large = false,
  showPrice = true
}: CtaButtonProps) {
  const destination = checkout ? 'https://megapackairfryargentina.impultienda.ar/' : '#oferta-principal';
  const ariaLabel = checkout ? 'Ir al checkout seguro del MegaPack' : 'Ir a la oferta principal del MegaPack';
  return <div className="mx-auto w-full max-w-xl" data-id="element-41" data-mp="vbshptxez4ev">
      {showCuotas && <div className="mb-3 flex justify-center" data-id="element-42" data-mp="19aa2bis0w0sk">
          <span className="inline-flex items-center gap-2 rounded-full bg-orange-100 px-4 py-1.5 text-sm font-bold text-orange-900" data-id="element-43" data-mp="198yzbl6eix2i">
            <ZapIcon className="h-4 w-4" data-id="element-44" data-mp="35xnzwvgqa4jw" /> En hasta 3 cuotas · Acceso inmediato
          </span>
        </div>}
      <motion.a href={destination} whileHover={{
      scale: 1.015
    }} whileTap={{
      scale: 0.985
    }} animate={{
      scale: [1, 1.01, 1]
    }} transition={{
      scale: {
        duration: 1.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }} aria-label={ariaLabel} className={`group flex w-full flex-col items-center justify-center rounded-2xl bg-orange-600 px-6 text-center shadow-[0_12px_28px_-8px_rgba(234,88,12,0.75)] transition-colors hover:bg-orange-700 ${large ? 'min-h-[76px] py-5 sm:min-h-[86px] sm:py-6' : 'py-5'}`} data-id="element-45" data-mp="39xzmwewkcgyj">
        <span className={`font-extrabold uppercase leading-tight tracking-tight text-white ${large ? 'text-lg sm:text-2xl' : 'text-lg sm:text-2xl'}`} data-id="element-46" data-mp="6hrd4wnn8i4r">
          {label}
        </span>
        {showPrice && <span className="mt-1 text-xl font-black text-yellow-200 sm:text-2xl" data-id="element-47" data-mp="gfyrd7qjsm32">POR $14.900</span>}
      </motion.a>
      {subtitle && <p className="mt-2 text-center text-sm font-bold text-white" data-id="element-48" data-mp="3myihfeftay9w">{subtitle}</p>}
      <div className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs font-medium text-neutral-500" data-id="element-49" data-mp="3hyw311o8zbzi">
        <span className="flex items-center gap-1" data-id="element-50" data-mp="io0tmd1ijef"><ZapIcon className="h-3.5 w-3.5 text-orange-600" data-id="element-51" data-mp="jpdfv9pfdy9" /> Acceso inmediato</span>
        <span className="flex items-center gap-1" data-id="element-52" data-mp="3rv8x40npfrus"><LockIcon className="h-3.5 w-3.5 text-orange-600" data-id="element-53" data-mp="9iauflzj2kwx" /> Pago seguro</span>
        <span className="flex items-center gap-1" data-id="element-54" data-mp="9kdoch3swy6x">🛡️ Garantía 7 días</span>
      </div>
      {showPaymentSeal && <div className="mt-4 flex justify-center" data-id="element-55" data-mp="jggr9p6h90ux">
          <img src="https://cdn.magicpatterns.com/uploads/pWoCPekSYcazdCDvugwUjT/pasted-image.jpg" alt="Mercado Pago, tarjetas y compra 100% segura con SSL" className="h-32 w-auto max-w-full rounded-lg bg-white object-contain p-1" data-id="element-56" data-mp="jfyyx3mxr6sa" />
        </div>}
    </div>;
}